<template>
  <transition name="slide-fade">
    <div class="loading" v-if="active">
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
  </transition>
  <transition name="slide-fade">
    <div class="loading bar" v-if="counter?.active">
      <section>
        <div class="logo">SPOTM<i class="material-icons">cell_tower</i>STER</div>
        <strong>{{ $t("loading.generate_block") }}</strong>
        <div class="time-bar">
          <div class="time-bar__progress" :style="{right: `${remaningTime * 100 / counter.time}%`}"></div>
        </div>
        <span>
          {{ $t("loading.remaining_time") }}: <span>{{ finished ? '-' : remaningTimeFormatted }}</span>
        </span>
      </section>
    </div>
  </transition>
</template>
<script>
import { computed, watch, ref } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const active = computed(() => store.getters.loading_getActive);
    const counter = computed(() => store.getters.loading_getCounter);
    const finished = ref(false);
    let remaningTime = ref(0);
    const remaningTimeFormatted = computed(() => {
      const totalSeconds = Math.floor(remaningTime.value / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    });
    
    let interval = null;
    watch(counter, (value) => {
      if (value.active) {
        if (interval) {
          finished.value = false;
          clearInterval(interval);
        }
        remaningTime.value = value.time;
        interval = setInterval(() => {
          if (remaningTime.value < 50) { 
            remaningTime.value = value.time;
            finished.value = true;
            return;
          }
          remaningTime.value -= 50;
        }, 50);
      } else {
        if (interval) {
          finished.value = false;
          clearInterval(interval);
        }
      }
    })

    return {
      active,
      counter,
      remaningTime,
      remaningTimeFormatted,
      finished
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  background: rgba(0,0,0,.3);

  &.bar {
    section {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 8px;
      padding: 16px;
      background: $lighter-gray-color;
      border-radius: 12px;

      strong {
        font-size: 16px;
      }

      span {
        margin-left: auto;
      }
    }
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  
    &:nth-child(1) {
      left: 8px;
      animation: lds-ellipsis1 0.6s infinite;
    }
    &:nth-child(2) {
      left: 8px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    &:nth-child(3) {
      left: 32px;
      animation: lds-ellipsis2 0.6s infinite;
    }
    &:nth-child(4) {
      left: 56px;
      animation: lds-ellipsis3 0.6s infinite;
    }
  }
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.logo {
  font-size: 28px;
  display: flex;
  align-items: center;
  font-family: "Roboto Condensed", sans-serif;

  i {
    margin-top: -14px;
    font-size: 40px;
  }
}

.time-bar {
  height: 16px;
  width: 600px;
  background: $dark-gray-color;
  border-radius: 2px;
  position: relative;
  overflow: hidden;

  &__progress {
    background: $primary-color;
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    transition: .3s ease-in-out width;
  }
}
</style>